import { withLazyFallback } from 'lib/hoc/withLazyFallback';
import SelfSchedulingContextProvider from 'lib/context/SelfSchedulingContext/SelfSchedulingContextProvider';

const SelfSchedulingV2 = withLazyFallback(
  () => import('components/Patient/SelfSchedulingV2/SelfSchedulingV2')
);

const Terms = withLazyFallback(() => import('components/Terms'));
const Unsubscribe = withLazyFallback(() => import('components/Unsubscribe/Unsubscribe'));

const SELF_SCHEDULING = [
  {
    path: 'book', // TODO: @rasim discuss to rename this to self-scheduling
    handle: { title: 'Book an appointment' },
    element: (
      <SelfSchedulingContextProvider>
        <SelfSchedulingV2 />
      </SelfSchedulingContextProvider>
    )
  },
  { path: 'terms', element: <Terms /> },
  { path: 'unsubscribe', element: <Unsubscribe /> }
];

export default SELF_SCHEDULING;
